module.exports = __webpack_public_path__ + "static/media/icon_search.218042c4.svg";